import { createSlice } from "@reduxjs/toolkit";

const safeJsonParse = (item) => {
  try {
    return JSON.parse(item);
  } catch {
    return null;
  }
};

const storedUser = localStorage.getItem("user");
const parsedUser = storedUser ? safeJsonParse(storedUser) : null;

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: !!parsedUser,
    user: parsedUser,
    loading: false,
    error: null,
  },
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    loginFailure: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
      state.loading = false;
      state.error = action.payload;
      localStorage.removeItem("user");
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem("user");
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, clearError } =
  authSlice.actions;

export default authSlice.reducer;
